// extracted by mini-css-extract-plugin
export default {"container":"CounterpartiesPage_container_jbfoc","content":"CounterpartiesPage_content_rHwon"};